import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import { thunk } from "redux-thunk";
import { authReducer } from "./Auth/Reducer";
import { learnerReducer } from "./Learner/Reducer";
import { enumReducer } from "./Enum/Reducer";
import { courseReducer } from "./Course/Reducer";
import { moduleReducer } from "./Module/Reducer";
import { chapterReducer } from "./Chapter/Reducer";
import { cartReducer } from "./Cart/Reducer";
import { quizReducer } from "./Quiz/Reducer";
import { articleReducer } from "./Article/Reducer";
import { orderReducer } from "./Order/Reducer";
import { instructorReducer } from "./Instructor/Reducer";
import { countryReducer } from "./Country/Reducer";
import { reviewReducer } from "./Review/Reducer";
import { commentReducer } from "./Comment/Reducer";
import { userReducer } from "./User/Reducer";
import { userLogReducer } from "./UserLog/Reducer";

const rootReducers = combineReducers({
  auth: authReducer,
  learner: learnerReducer,
  enums: enumReducer,
  course: courseReducer,
  module: moduleReducer,
  chapter: chapterReducer,
  cart: cartReducer,
  quiz: quizReducer,
  article: articleReducer,
  order: orderReducer,
  instructor: instructorReducer,
  country: countryReducer,
  review: reviewReducer,
  comment: commentReducer,
  user: userReducer,
  userLog: userLogReducer,
});

export const store = legacy_createStore(rootReducers, applyMiddleware(thunk));
